import {
  Button,
  makeStyles,
  Snackbar,
  TableCell,
  TableRow,
  TextField,
  withStyles,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useEffect } from 'react';
import { MdPersonAddAlt1 } from 'react-icons/md';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#2490AF',
    color: theme.palette.common.white,
    fontSize: 17,
    fontFamily: 'Roboto',
  },
  body: {
    fontSize: 14,
    fontFamily: 'Roboto',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
});

export function useAsignatures() {
  const [asignatures, setAsignatures] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/asignatures')
      .then((response) => response.json())
      .then((data) => {
        setAsignatures(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { asignatures, setAsignatures };
}

export default function CreateAsignature() {
  const classes = useStyles();
  const { asignatures, setAsignatures } = useAsignatures();
  const [name, setName] = React.useState('');
  const [snackCreateSuccessOpen, setSnackCreateSuccessOpen] =
    React.useState(false);
  const [snackCreateInfoOpen, setSnackCreateInfoOpen] = React.useState(false);
  const [snackErrorOpen, setSnackErrorOpen] = React.useState(false);
  const [selectedAsignature, setSelectedAsignature] = React.useState(null);
  const handleSnackCreateSuccessClose = () => {
    setSnackCreateSuccessOpen(false);
  };

  const handleSnackErrorClose = () => {
    setSnackErrorOpen(false);
  };

  const handleSnackCreateInfoClose = () => {
    setSnackCreateInfoOpen(false);
  };
  const handleCreate = async () => {
    try {
      if (name) {
        let response = await fetch(
          'https://api.edicionesmilenio.com/api/asignatures',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              name,
            }),
          }
        );
        let data = await response.json();
        if (data.success === true) {
          setAsignatures([...asignatures, data?.data]);
          setSnackCreateSuccessOpen(true);
        } else {
          setSnackErrorOpen(true);
        }
        setName('');
      } else {
        setSnackCreateInfoOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleUpdate = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/asignatures/${selectedAsignature?._id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name,
          }),
        }
      );

      let data = await response.json();
      if (data.success) {
        let index = asignatures.findIndex(
          (g) => g._id === selectedAsignature?._id
        );
        asignatures.splice(index, 1, data?.data);
        setAsignatures(asignatures);
        setSelectedAsignature(data?.data);
        setSnackCreateSuccessOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleDelete = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/asignatures/${selectedAsignature?._id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name,
          }),
        }
      );

      let data = await response.json();
      if (data.success) {
        let asignaturesDeleted = asignatures.filter(
          (g) => g?._id !== selectedAsignature?._id
        );
        setAsignatures(asignaturesDeleted);
        setSnackCreateSuccessOpen(true);

        setName('');
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  useEffect(() => {
    if (selectedAsignature) {
      setName(selectedAsignature?.name);
    }
  }, [selectedAsignature]);
  return (
    <div className={classes.container} style={{ width: '100%' }}>
      {/* <TableContainer className={classes.TableContainer} component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nombre</StyledTableCell>
              <StyledTableCell>Fecha De Creación</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {asignatures.map((row) => (
              <StyledTableRow
                onClick={() => setSelectedAsignature(row)}
                key={row._id}
              >
                <StyledTableCell>{row.name}</StyledTableCell>
                <StyledTableCell>{row.createdAt}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <form className={classes.form} noValidate autoComplete="off">
        <p className={classes.formSpan}>
          Estimado administrador, desde esta sección podrás crear una nueva
          asignatura en la plataforma, escribe a continuación su nombre,
          recuerda que debes realizar los proceso de asociación dentro de la
          plataforma.
        </p>
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Nombre de la asignatura"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Button
          onClick={() => {
            setSelectedAsignature(null);
            setName('');
          }}
        >
          Limpiar
        </Button>
        <div className={classes.formButtonsContainer}>
          {/* <Button
            variant='contained'
            color='secondary'
            onClick={handleDelete}
          >
            <FaTrash size={15} />
            Eliminar
          </Button> */}
          {/* <Button
            variant='contained'
            onClick={handleUpdate}
          >
            <AiFillEdit size={15} />
            Actualizar
          </Button> */}
          <Button onClick={handleCreate} variant="contained" color="primary">
            <MdPersonAddAlt1 size={15} />
            Crear
          </Button>
        </div>
      </form>
      <Snackbar
        open={snackCreateSuccessOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateSuccessClose}
      >
        <Alert onClose={handleSnackCreateSuccessClose} severity="success">
          Se ha creado la asignatura exitosamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackCreateInfoOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateInfoClose}
      >
        <Alert onClose={handleSnackCreateInfoClose} severity="warning">
          Estimado administrador para crear una asignatura, por favor llene los
          campos requeridos
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackErrorOpen}
        autoHideDuration={6000}
        onClose={handleSnackErrorClose}
      >
        <Alert onClose={handleSnackErrorClose} severity="error">
          Hubo un error al intentar realizar la operación, por favor intente
          nuevamente
        </Alert>
      </Snackbar>
    </div>
  );
}
